/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterS = createReactComponent("letter-s", "IconLetterS", [
  [
    "path",
    {
      d: "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4",
      key: "svg-0"
    }
  ]
]);

export { IconLetterS as default };
//# sourceMappingURL=IconLetterS.js.map
